//#region src/i9n_sync_scope.ts
let I9nSyncScope = /* @__PURE__ */ function(I9nSyncScope) {
	I9nSyncScope["AvailabilityOnly"] = "availability-only";
	I9nSyncScope["FullSync"] = "full-sync";
	return I9nSyncScope;
}({});
//#endregion
export { I9nSyncScope };

//# sourceMappingURL=i9n_sync_scope.js.map